<div #stickyAnchor></div>
<div class="navbar-placeholder" [style.height.px]="isSticky ? navbarHeight : 0"></div>
<nav #navbar class="navbar" [class.sticky]="isSticky">
  <!-- <div class="navbar-container-wrapper"> -->
    <button class="nav-arrow left" (click)="scrollNav('left')" [class.disabled]="!canScrollLeft">
      <img src="assets/official-website/arrow-left.png" alt="Left" />
    </button>
    <div #navScroll class="navbar-container" (scroll)="checkScrollArrows()">
      <ul>
        <li *ngFor="let section of sections" [class.active]="activeSection === section.id">
          <a [href]="'#' + section.id" (click)="onNavClick(section.id, $event)">
            {{ section.label }}
          </a>
        </li>
      </ul>
    </div>
    <button class="nav-arrow right" (click)="scrollNav('right')" [class.disabled]="!canScrollRight">
      <img src="assets/official-website/arrow-right.png" alt="Right" />
    </button>
  <!-- </div> -->
</nav>